// extracted by mini-css-extract-plugin
export default {"pdf-mode":"informe_pdf-mode__aptp+","page-1":"informe_page-1__TX3HI","page-2":"informe_page-2__U3Rn2","page-3":"informe_page-3__edKD5"};